(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (!document.body.classList.contains('sparkedc-atelier')) return;
    initSectionNumbers();
    initProductIndexes();
    initHeroCopyAnimation();
  });

  function initSectionNumbers() {
    document.querySelectorAll('.nxedc-section').forEach(function (section, i) {
      var num = section.querySelector('.nxedc-section__num');
      var numText = String(i + 1).padStart(2, '0');
      if (num) {
        num.textContent = numText;
        return;
      }
      var head = section.querySelector('.nxedc-section__head-text');
      if (head) head.setAttribute('data-section-num', numText);
    });
  }

  function initProductIndexes() {
    document.querySelectorAll('.nxedc-product-grid, .nxedc-products-grid__items, .nxedc-products-swiper .swiper-wrapper').forEach(function (wrap) {
      var cards = wrap.querySelectorAll('.sp-product-card, .nxedc-glozin-card');
      cards.forEach(function (card, i) {
        var frame = card.querySelector('.sp-product-card__frame, .nxedc-glozin-card__media');
        if (!frame || frame.querySelector('.sp-product-card__index')) return;
        var index = document.createElement('span');
        index.className = 'sp-product-card__index';
        index.textContent = String(i + 1).padStart(2, '0');
        index.setAttribute('aria-hidden', 'true');
        frame.appendChild(index);
      });
    });
  }

  function initHeroCopyAnimation() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var style = document.createElement('style');
    style.textContent = [
      '@keyframes sp-copy-in { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }',
      '.sparkedc-atelier [data-nxedc-hero-heading],',
      '.sparkedc-atelier [data-nxedc-hero-text],',
      '.sparkedc-atelier [data-nxedc-hero-actions],',
      '.sparkedc-atelier [data-nxedc-hero-eyebrow] { animation: sp-copy-in 0.6s cubic-bezier(0.22, 1, 0.36, 1) both; }'
    ].join('\n');
    document.head.appendChild(style);
  }
})();
